export default {
  storeTo: 'Lager nach',
  weightHaveUnit: 'Gewicht (g)',
  productType: 'Produkttyp',
  long: 'Länge (cm)',
  width: 'Breite (cm)',
  height: 'Höhe (cm)',
  seeDetail: 'Details anzeigen',
  queryTips: 'Bitte geben Sie die entsprechenden Parameter ein, um die Fracht zu prüfen!',
  carrier: 'Spediteur',
  carrierCode: 'Spediteurcode',
  product: 'Produkt',
  productCode: 'Produktcode',
  totalfee: 'Gesamtkosten',
  billingWeight: 'Berechnetes Gewicht',
  feeEstimation: 'Kostenschätzung',
  postFeeEstimation: 'Versandschätzung',
  postFee: 'Versandkosten',
  postTime: 'Voraussichtliche Versandzeit',
  packUp: 'Einklappen',
  startWeight: 'Startgewicht',
  endWeight: 'Endgewicht',
  calcExpression: 'Berechnungsausdruck',
  baseFreight: 'Grundfracht',
  registrationFee: 'Registrierungsgebühr',
  noSend: 'Nicht verfügbare Produkte',
  canSend: 'Verfügbare Produkte',
  priceFrom: 'Kostenaufstellung',
  itemLimit: 'Artikelbegrenzung',
  disReason: 'Grund für Nichtverfügbarkeit',
  BasicFreight: 'Grundfracht',
  OperationFreight: 'Zoll- und Deklarationsgebühr',
  RegistrationFreight: 'Registrierungsgebühr',
  IossFee: 'IOSS-Gebühr',
  TariffFreight: 'Zollgebühr',
  VATFregith: 'Mehrwertsteuer (MwSt.)',
  AserviceFee: 'Zusätzliche Servicegebühr',
  ExtraSizeFreight: 'Übergrößenzuschlag',
  AdditionalDeliveryFeeForFemoteAreas: 'Zusätzliche Liefergebühr für abgelegene Gebiete',
  FuelSurcharge: 'Treibstoffzuschlag',
  zoneCode: 'Zone',
  amount: 'Preis',
  rate: 'Satz',
  conditionExpression: 'Berechnung',
  feeFactor: 'Gebührenfaktor',
  continuedPrice: 'Preis für Zusatzgewicht',
  continuedWeight: 'Zusatzgewicht (g)',
  firstPrice: 'Preis für Erstgewicht',
  firstWeight: 'Erstgewicht (g)',
  weightRangeStart: 'Startgewicht (g)',
  weightRangeEnd: 'Endgewicht (g)',
  holder: {
    toCountry: 'Zielort wählen',
    inputWeight: 'Bitte Gewicht eingeben',
    selectCountry: 'Bitte Land auswählen',
    selectCarrier: 'Bitte Spediteur/Speditionslinie/Zielland auswählen',
    selectCategory: 'Versandeinschränkung wählen',
  },
  typeDelivery: 'Versandarten',
  shippingTime: 'Voraussichtliche Versandzeit',
  workDay: 'Werktage',
  deliveryTips: 'Lieferhinweise',
  estimatedShippingFee: 'Voraussichtliche Versandkosten',
  lineServiceTips:
    'Hinweis: Alle Logistikdienstleistungen für nicht von acbuy selbst betriebene Routen werden von Drittanbietern erbracht, die die Frachtpreise entsprechend den Marktbedingungen anpassen. Bei Preisänderungen wird acbuy Sie im Voraus benachrichtigen. Sollten Sie Probleme mit Logistikdienstleistungen haben, kann acbuy in Ihrem Namen mit dem Drittanbieter kommunizieren.',
  logisticsStatement: '<Hinweis zu Logistikdienstleistungen>',
  customizedDelivery: 'Maßgeschneiderter Lieferservice',
  customizedDeliveryText:
    'Sperrgutversand, See- und Schienentransport, Sie können einen maßgeschneiderten Lieferservice wählen',
  customizeNow: 'Jetzt anpassen',
  declareAmountRange: 'Spanne des Deklarationsbetrags',
  viewUnavailableLines: 'Nicht verfügbare Linien anzeigen (nicht verfügbar:',
  'i18n-0000001': 'Lieferrate',
  'i18n-0000002':
    'Für alle Pakete, die zwischen dem {startTime} und dem {endTime} versandt wurden, der prozentuale Anteil der Pakete, die bis heute zugestellt wurden',
  'i18n-0000003': 'Tage',
  couponDiscount: 'Gutscheinrabatt',
  expectedDiscount: 'Erwarteter Rabatt',
}
